import { RouteLocationNormalized } from 'vue-router'

import { AppStateEnum } from '@/enums'

export type GlobalState = {
  appState: AppStateEnum,
  mini: boolean,
  isPendoLoaded: boolean,
  homeLayout: boolean,
  projectLayout: boolean,
  toggleProjectDrawer: boolean,
  badgeProfileVisible: boolean,
  navigationDrawerProfile: boolean,
  routerHistory: RouteLocationNormalized[], 
}

export const state: GlobalState = {
  appState: AppStateEnum.loading,
  mini: false,
  isPendoLoaded: false,
  homeLayout: false,
  projectLayout: false,
  toggleProjectDrawer: false,
  badgeProfileVisible: true,
  navigationDrawerProfile: false,
  routerHistory: [],
}
